var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"height":"420px","indicator-position":""}},_vm._l((4),function(item){return _c('el-carousel-item',{key:item},[_c('h3',[_vm._v(_vm._s(item))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }